import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectTagFilters, setTagsFilters} from './slice';

import type {TagsDashboardFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';
export function useTagFilters(
  location: Location<TagsDashboardFetchParamsType>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectTagFilters,
    useAsyncActions({
      setTagsFilters,
    }).setTagsFilters,
    convertLocationParamsToFetchParams
  );
}
